import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpenseWorkflowModal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 45,
	height: 45,
	viewBox: "0 0 45 45",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M27.8037 5.29004V14.4567H36.9704",
			stroke: "#FF3131",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7.63721,
			y: 4.4834,
			width: 29.3333,
			height: 35.6401,
			rx: 4,
			stroke: "#FF3131",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.6374 30.0407H14.9707",
			stroke: "#FF3131",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.6374 22.7067H14.9707",
			stroke: "#FF3131",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.4707 15.3737H14.9707",
			stroke: "#FF3131",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		})
	]
});
export default SvgExpenseWorkflowModal;
